/**
 * @generated SignedSource<<0df4a9d82dfeaa6c96bcb4ebf6d258c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineStatusOverviewListItem_dimension$data = {
  readonly completedCount: number;
  readonly id: string;
  readonly label: string;
  readonly startedCount: number;
  readonly totalCount: number;
  readonly " $fragmentType": "WorkspaceRoutineStatusOverviewListItem_dimension";
};
export type WorkspaceRoutineStatusOverviewListItem_dimension$key = {
  readonly " $data"?: WorkspaceRoutineStatusOverviewListItem_dimension$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineStatusOverviewListItem_dimension">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineStatusOverviewListItem_dimension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedCount",
      "storageKey": null
    }
  ],
  "type": "RoutineWorkspaceCompletionDimension",
  "abstractKey": null
};

(node as any).hash = "b5cac2aa6c02b18bea424438447e64ac";

export default node;
